import * as React from "react";
import {
  Box,
  IconButton,
  Dialog,
  DialogContent,
  Grow,
  DialogTitle,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { merge } from "lodash";
import { useModalScrollBlocker } from "src/utils/useModalScrollBlocker";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />;
});

const CenterDialog = React.forwardRef(
  (
    {
      open,
      handleClose,
      children,
      dialogTitle,
      maxWidth = "sm",
      dividers,
      sx = {},
      hideCloseButton = false,
      openOnScroll = false,
      originalPadding = false, // MUI default padding (recommended on hideCloseButton=true without dividers)
      BackdropProps = {},
      ...props
    },
    ref
  ) => {
    const CloseButton = () => {
      return (
        <IconButton
          edge="end"
          color="inherit"
          variant="outlined"
          data-testid="dialog-close-button"
          onClick={handleClose}
          aria-label="close"
          sx={{ position: "absolute", top: "12px", right: "32px", zIndex: 30 }}
        >
          <Close fontSize="small" />
        </IconButton>
      );
    };

    useModalScrollBlocker({ open, enabled: !props.disableScrollLock });

    return (
      <Dialog
        ref={ref}
        container={document.getElementById("portal-root")}
        disableScrollLock={true}
        sx={merge(
          {
            ".MuiDialog-paper": { borderRadius: "16px" },
            ".MuiDialog-container": {
              "@supports (height: 100dvh)": { minHeight: "100dvh" },
              "@supports not (height: 100dvh)": {
                minHeight: "-webkit-fill-available",
              },
            },
          },
          sx
        )}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        TransitionComponent={openOnScroll ? undefined : Transition}
        BackdropProps={{
          ...merge(
            {
              sx: {
                "@supports (height: 100dvh)": { height: "100dvh" },
                "@supports not (height: 100dvh)": {
                  height: "-webkit-fill-available",
                },
              },
            },
            BackdropProps ?? {}
          ),
          ref: BackdropProps.ref, // should go outside merge function
        }}
        {...props}
      >
        {dialogTitle ? (
          <DialogTitle sx={{ m: 0, p: 2, ml: 1, fontSize: "16px" }}>
            {dialogTitle}
          </DialogTitle>
        ) : (
          // The close X is absolutely positioned, so its row is reserved even
          // with no title, or the first line of content runs under it.
          !hideCloseButton && <Box sx={{ minHeight: "40px" }} />
        )}
        {!hideCloseButton && <CloseButton />}
        <DialogContent
          dividers={dividers}
          sx={{ padding: originalPadding ? "20px 24px" : "16px 24px 32px" }}
        >
          {children}
        </DialogContent>
      </Dialog>
    );
  }
);

export default CenterDialog;
